import ReadMoreByCount from './ByCount';
import ReadMoreByLine from './ByLine';
import { ByCountProps, ByLineProps } from './types';

type Props = ByCountProps | ByLineProps;

const ReadMore = (props: Props) => {
  if ('maxChar' in props) {
    return <ReadMoreByCount {...props} />;
  } else if ('maxLine' in props) {
    return <ReadMoreByLine {...props} />;
  }
  return null;
};

export default ReadMore;
